import { useState, useEffect } from "react";
import Navbar from "../Navbar/Navbar";
import Table from "../Table/Table";
import Table_Buttons from "../Table_Button/Table_button";
import { toast } from "react-toastify";
import { API } from "../../Redux/actions/API";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { updateAuth } from "../../Redux/actions/AdminAuthSlice";
import Spinner from "../Spinner/Spinner";

export default function MonthWisePayout() {
  const { userId, jwt_token } = useSelector((state) => state.Auth);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [isLoading, setisLoading] = useState(false);
  const [currentPage, setcurrentPage] = useState(1);
  const [listPerpage, setlistPerpage] = useState(10);
  const [leftreferralApi, setleftreferralApi] = useState([]);
  const [search, setSearch] = useState("");
  const [todate, setTodate] = useState("");
  const [formdate, setFromdate] = useState("");

  const [Months, setMonths] = useState(0);
  const [Years, setYears] = useState(0);
  const [out, setOut] = useState([]);

  const [totals, setTotals] = useState({
    trading: 0,
    intro: 0,
    leadership: 0,
    income: 0,
    deduction: 0,
    payable: 0,
  });

  const List_API = async () => {
    try {
      const response = await API.post(
        "/PayoutReportAdmin",
        {
          loginid: userId,
          uid: 0,
          report: "BindDropDown",
          months: 0,
          years: 0,
        },
        {
          headers: { Authorization: jwt_token },
        },
      );

      setOut(response?.data?.data[0] || []);
    } catch (e) {
      console.log(e);
    }
  };

  const referral_API = async (monthValue = Months, yearValue = Years) => {
    try {
      setisLoading(true);

      let responceRight = await API?.post(
        "/PayoutReportAdmin",
        {
          loginid: userId,
          uid: search.slice(2),
          report: "MonthWisePayoutAdmin",
          months: monthValue,
          years: yearValue,
        },
        {
          headers: {
            Authorization: jwt_token,
          },
        },
      );

      // setTotalAmount(responceRight?.data?.data[0][0].TotalAmount);
      responceRight = responceRight?.data?.data[0];
      console.log("payout", responceRight);
      setleftreferralApi([]);
      const formatted = responceRight.map((item, index) => ({
        sr: index + 1,
        uid: `AC${item.uid}`,
        name: item.f_name,

        tradingBonus: `$ ${item.total_trading_income?.toFixed(4)}`,
        introBonus: `$ ${item.total_introduction_bonus?.toFixed(4)}`,
        leadershipBonus: `$ ${item.LeadershipPerformanceBonus?.toFixed(4)}`,

        totalIncome: `$ ${item.Total_income?.toFixed(4)}`,
        tds: `$ ${item.Tdsdeduction?.toFixed(4)}`,
        netPayable: `$ ${item.NetPayable?.toFixed(4)}`,

        month: `${item.months} - ${item.years}`,
      }));

      setleftreferralApi(formatted);
    } catch (e) {
      console.log("error Balance APi", e);
      if (
        e.response.data.showableMessage ==
        "Please login to access this resource"
      ) {
        dispatch(updateAuth({ AdminAuth: false, jwt_token: "", userId: null }));
        sessionStorage.clear();
        localStorage.clear();
        navigate("/");
      }
    } finally {
      setisLoading(false);
    }
  };

  useEffect(() => {
    // referral_API();
    List_API();
  }, []);

  const indexOfLastPost = currentPage * listPerpage;
  const indexOfFirstPage = indexOfLastPost - listPerpage;
  const currentPostleft = leftreferralApi.slice(
    indexOfFirstPage,
    indexOfLastPost,
  );

  const [my_team] = useState({
    cols: [
      { Header: "S.No", accessor: "sr" },
      { Header: "User Id", accessor: "uid" },
      { Header: "Name", accessor: "name" },
      { Header: "Total Trading Bonus", accessor: "tradingBonus" },
      { Header: "Total Introduction Bonus", accessor: "introBonus" },
      { Header: "Leadership Performance Bonus", accessor: "leadershipBonus" },
      { Header: "Total Income", accessor: "totalIncome" },
      { Header: "Deduction (5%)", accessor: "tds" },
      { Header: "Net Payble Amount", accessor: "netPayable" },
      { Header: "Month", accessor: "month" },
    ],
  });

  const exportToExcel = () => {
    if (!leftreferralApi.length) {
      toast.error("No data to export");
      return;
    }

    const excelData = leftreferralApi.map((item) => ({
      "S.No": item.sr,
      "User Id": item.uid,
      Name: item.name,
      "Total Trading Bonus": Number(item.tradingBonus.replace("$", "")),
      "Total Introduction Bonus": Number(item.introBonus.replace("$", "")),
      "Leadership Performance Bonus": Number(
        item.leadershipBonus.replace("$", ""),
      ),

      "Total Income": Number(item.totalIncome.replace("$", "")),
      "Deduction (5%)": Number(item.tds.replace("$", "")),
      "Net Payble Amount": Number(item.netPayable.replace("$", "")),
      Month: item.month,
    }));

    const worksheet = XLSX.utils.json_to_sheet(excelData);
    const workbook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(workbook, worksheet, "MonthWisePayout");

    XLSX.writeFile(workbook, "Month_Wise_Payout_Report.xlsx");
  };

  useEffect(() => {
    if (!leftreferralApi.length) return;

    const parseAmount = (val) => Number(val.replace("$", "").trim());

    const result = leftreferralApi.reduce(
      (acc, item) => {
        acc.trading += parseAmount(item.tradingBonus);
        acc.intro += parseAmount(item.introBonus);
        acc.leadership += parseAmount(item.leadershipBonus);
        acc.income += parseAmount(item.totalIncome);
        acc.deduction += parseAmount(item.tds);
        acc.payable += parseAmount(item.netPayable);
        return acc;
      },
      {
        trading: 0,
        intro: 0,
        leadership: 0,
        income: 0,
        deduction: 0,
        payable: 0,
      },
    );

    setTotals(result);
  }, [leftreferralApi]);

  return (
    <div>
      <Navbar />
      <div class="content-page">
        <div class="content">
          <div class="row">
            <div class="col-md-12">
              <div class="panel panel-primary">
                <div class="panel-heading">
                  <h4 class="panel-title">Month Wise Payout Income Details</h4>
                </div>
                <div class="panel-body">
                  <div class="row">
                    <div class="col-md-3">
                      <input
                        type="text"
                        id="txtuid"
                        ng-model="p.uid"
                        onChange={(e) => setSearch(e.target.value)}
                        class="form-control ng-pristine ng-untouched ng-valid ng-empty ng-valid-maxlength"
                        placeholder="Enter User Id"
                      />
                    </div>
                    <div class="col-md-3">
                      <select
                        className="form-control"
                        onChange={(e) => {
                          const [m, y] = e.target.value.split("-");
                          setMonths(Number(m));
                          setYears(Number(y));

                          referral_API(Number(m), Number(y));
                        }}>
                        <option value="">Select PayOut</option>

                        {out.map((item, index) => (
                          <option
                            key={index}
                            value={`${item.months}-${item.years}`}>
                            {item.payout}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div class="col-md-3">
                      <input
                        type="button"
                        id="btnsearch"
                        onClick={() => {
                          referral_API();
                        }}
                        class="btn btn-sm btn-primary"
                        value="Search"
                      />
                    </div>
                    <div className="col-md-3">
                      <button
                        className="btn btn-success btn-sm"
                        onClick={exportToExcel}>
                        Export to Excel
                      </button>
                    </div>
                  </div>
                  <div class="row">
                    <div className="col-6">
                      <h4>
                        <p>
                          Total Trading Bonus: $ {totals.trading?.toFixed(4)}
                        </p>
                        <p>
                          Total Introduction Bonus: $ {totals.intro?.toFixed(4)}
                        </p>
                        <p>
                          Total Leadership Performance Bonus: ${" "}
                          {totals.leadership?.toFixed(4)}
                        </p>
                      </h4>
                    </div>

                    <div className="col-6">
                      <h4>
                        <p>Total Income: $ {totals.income?.toFixed(4)}</p>
                        <p>Total Deduction: $ {totals.deduction?.toFixed(4)}</p>
                        <p>
                          Total Payble Amount:$ {totals.payable?.toFixed(4)}
                        </p>
                      </h4>
                    </div>

                    {isLoading ? (
                      <Spinner />
                    ) : (
                      <div className="col-md-12">
                        <Table data={currentPostleft} columns={my_team.cols} />

                        <Table_Buttons
                          indexOfFirstPage={indexOfFirstPage}
                          indexOfLastPost={indexOfLastPost}
                          setcurrentPage={setcurrentPage}
                          currentPage={currentPage}
                          totalData={leftreferralApi.length}
                          listPerpage={listPerpage}
                          handleRowsPerPageChange={setlistPerpage}
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
